module.exports = __webpack_public_path__ + "img/new.be5030ca.webp";